import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <g>
      <path d="M9 8.746c-1.831 0-3.485.75-4.677 1.956l1.417 1.417c.831-.845 1.984-1.373 3.26-1.373s2.429.528 3.26 1.373l1.417-1.417A6.552 6.552 0 0 0 9 8.746z" />
      <path d="M9 11.821c-.981 0-1.866.406-2.501 1.057L9 15.379l2.501-2.501A3.483 3.483 0 0 0 9 11.821zM9 2.621c-3.518 0-6.7 1.431-9 3.742v.017l1.41 1.41C3.35 5.834 6.035 4.621 9 4.621s5.65 1.213 7.59 3.168L18 6.379v-.016a12.657 12.657 0 0 0-9-3.742z" />
      <path d="M9 5.721a9.57 9.57 0 0 0-6.816 2.842L3.601 9.98C4.979 8.587 6.89 7.721 9 7.721s4.021.866 5.399 2.259l1.417-1.417A9.57 9.57 0 0 0 9 5.721z" />
    </g>
  </svg>
);

export default SvgComponent;
